/*
 * This module is currently not being used. Initially the design included it for customer selection
 * during manual case creation. However, the customer listing API is not available, and would require
 * significant work to develop. We keep this module here to be used when that API is ready.
 */
export const FETCH_CUSTOMERS = 'FETCH_CUSTOMERS';
export const FETCH_CUSTOMERS_SUCCESS = 'FETCH_CUSTOMERS_SUCCESS';
export const FETCH_CUSTOMERS_FAIL = 'FETCH_CUSTOMERS_FAIL';

export const fetchCustomers = ({ currentPage, pageSize }) => ({
  type: FETCH_CUSTOMERS,
  payload: { currentPage, pageSize }
});

export const fetchCustomersSuccess = ({ customers, total }) => ({
  type: FETCH_CUSTOMERS_SUCCESS,
  payload: { customers, total }
});

export const fetchCustomersFail = () => ({
  type: FETCH_CUSTOMERS_FAIL
});
